import { api } from '../../libs/api'

export default {
  namespaced: true,

  state: {
    companyName: '',
    enable: false,
  },
  mutations: {
    companyName: (state, value) => state.companyName = value,
    enable: (state, value) => state.enable = value,
  },
  actions: {
    async fetch ({ commit }) {
      try {
        const data = await api.fetchExclusionCompanyName()
        commit('companyName', data.company_name)
        commit('enable', data.enable)
      } catch (e) {
        return Promise.reject(e)
      }
    },
    async update ({ commit }, params) {
      const res = await api.updateExclusionCompanyName(params)
      const data = await res.data
      commit('companyName', data.company_name)
      commit('enable', data.enable)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/exclusionCompanyName.js